export default {"src":"/_next/static/media/calendar-dots-mobile.187bf829.svg","height":19,"width":26,"blurWidth":0,"blurHeight":0};